export default __webpack_public_path__ + "static/media/content-deco-4.b4f5b4ba.webp";